import * as React from "react";

const SvgFlipHorizontal = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 25 24"
  >
    <path
      fill="currentColor"
      d="M20.412 22h-16l8-19zm-8-14.5v.65l-5 11.85h5V4v3.5"
    />
  </svg>
);
export default SvgFlipHorizontal;
